"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProDialogProps = void 0;
var react_1 = __importDefault(require("react"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var spaui_1 = require("@tencent/spaui");
var odc_flex_1 = __importDefault(require("@tencent/odc-flex"));
var odc_titlebar_1 = __importDefault(require("@tencent/odc-titlebar"));
var odc_toolbar_1 = __importDefault(require("@tencent/odc-toolbar"));
var classnames_1 = __importDefault(require("classnames"));
exports.ProDialogProps = {
  hideHeader: true,
  hideFooter: true,
  closeButton: false,
  useNewUI: true
};
var ProDialogBodyComponent = function ProDialogBodyComponent(props) {
  var title = props.title,
    subTitle = props.subTitle,
    onClose = props.onClose,
    onCancel = props.onCancel,
    onSubmit = props.onSubmit,
    cancelButtonProps = props.cancelButtonProps,
    cancelLabel = props.cancelLabel,
    submitLabel = props.submitLabel,
    submitButtonProps = props.submitButtonProps,
    children = props.children,
    FooterLeftComponent = props.FooterLeftComponent,
    // eslint-disable-line
    RightComponent = props.RightComponent,
    // eslint-disable-line
    _a = props.hideFooterDivider,
    // eslint-disable-line
    hideFooterDivider = _a === void 0 ? false : _a,
    bodyHeight = props.bodyHeight;
  return react_1["default"].createElement(odc_flex_1["default"], __assign({
    fill: 'var(--od-color-solid-black-1)',
    h: bodyHeight
  }, (0, spaui_utils_1.globalProps)(props, {
    className: 'radius-8',
    supportAllEvents: true
  }, ProDialogBodyComponent)), react_1["default"].createElement(odc_flex_1["default"], {
    column: true,
    className: 'bg-white min-h-0 shadow-2 radius-8 flex-auto min-w-0'
  }, react_1["default"].createElement(odc_titlebar_1["default"], {
    size: 4,
    className: 'px-24 py-16 border-b',
    title: title,
    desc: subTitle,
    rightClassName: 'self-center',
    right: react_1["default"].createElement(spaui_1.Button, {
      width: 36,
      className: '-my-8 -mx-12 l-dialog-close',
      displayType: 'text',
      icon: react_1["default"].createElement(spaui_1.Icon, {
        className: 'text-secondary',
        type: 'x-close',
        strokeWidth: 2,
        boxGap: 1,
        boxSize: 16,
        strokeRadius: 1
      }),
      onClick: onClose
    })
  }), children, react_1["default"].createElement(odc_toolbar_1["default"], {
    className: (0, classnames_1["default"])('pt-11 pb-24 px-24 dialog-footer', {
      'border-t': hideFooterDivider
    }),
    left: typeof FooterLeftComponent === 'function' ? react_1["default"].createElement(FooterLeftComponent, null) : null,
    right: react_1["default"].createElement(odc_flex_1["default"], {
      gap: 8
    }, react_1["default"].createElement(spaui_1.Button, __assign({
      onClick: onCancel
    }, cancelButtonProps), cancelLabel), react_1["default"].createElement(spaui_1.Button, __assign({
      displayType: 'primary',
      onClick: onSubmit
    }, submitButtonProps), submitLabel))
  })), typeof RightComponent === 'function' ? react_1["default"].createElement(RightComponent, null) : null);
};
(0, spaui_utils_1.setComponentMark)(ProDialogBodyComponent, info_1["default"]);
exports["default"] = react_1["default"].memo(ProDialogBodyComponent);